// Services offered on the /services page. `category` drives the filter chips.
export const serviceCategories = [
  { id: 'all', label: 'All services', icon: 'fa-border-all' },
  { id: 'ai', label: 'AI & Automation', icon: 'fa-wand-magic-sparkles' },
  { id: 'telecom', label: 'Telecom & VoIP', icon: 'fa-tower-broadcast' },
  { id: 'software', label: 'Software', icon: 'fa-code' },
  { id: 'data', label: 'Data', icon: 'fa-database' },
  { id: 'business', label: 'Business & Training', icon: 'fa-briefcase' },
  { id: 'support', label: 'Support & Security', icon: 'fa-shield-halved' }
]

export const services = [
  {
    id: 'voip',
    category: 'telecom',
    icon: 'fas fa-phone-alt',
    title: 'VoIP & Telecommunications Solutions',
    description: 'Comprehensive VoIP-based telecommunications solutions for businesses and service providers.',
    features: [
      'Calling Platforms & SIP Servers',
      'Billing & Rating Engines',
      'Online Charging Systems (OCS)',
      'VoIP Mobile Applications',
      'Call Routing & Management',
      'Real-time Billing Solutions'
    ],
    technologies: ['OpenSIPS', 'CGRates', 'Node.js', 'Golang', 'Flutter', 'Docker']
  },
  {
    id: 'mobile',
    category: 'software',
    icon: 'fas fa-mobile-alt',
    title: 'Mobile Application Development',
    description: 'Custom mobile applications for business processes, payments, and enterprise solutions.',
    features: [
      'Cross-platform Mobile Apps',
      'Payment Gateway Integration',
      'Business Process Automation',
      'Enterprise Mobile Solutions',
      'API Integration',
      'Real-time Data Synchronization'
    ],
    technologies: ['Flutter', 'React Native', '.NET MAUI', 'Firebase', 'REST APIs', 'gRPC']
  },
  {
    id: 'data',
    category: 'data',
    icon: 'fas fa-database',
    title: 'Data Warehousing Solutions',
    description: 'Scalable data storage, management, and analytics solutions for business intelligence.',
    features: [
      'Data Warehouse Architecture',
      'ETL Processes & Pipelines',
      'Business Intelligence Solutions',
      'Real-time Analytics',
      'Data Migration Services',
      'Performance Optimization'
    ],
    technologies: ['ClickHouse', 'PostgreSQL', 'MongoDB', 'Python', 'Apache Kafka', 'Redpanda']
  },
  {
    id: 'software',
    category: 'software',
    icon: 'fas fa-code',
    title: 'Custom Software Development',
    description: 'Tailored software solutions built with modern technologies and best practices.',
    features: [
      'Web Application Development',
      'Microservices Architecture',
      'RESTful & SOAP APIs',
      'Cloud-based Solutions',
      'Legacy System Modernization',
      'DevOps & CI/CD Implementation'
    ],
    technologies: ['Node.js', '.NET', 'Python', 'React', 'Vue.js', 'Docker', 'Kubernetes']
  },
  {
    id: 'architecture',
    category: 'software',
    icon: 'fas fa-sitemap',
    title: 'System Architecture & Consulting',
    description: 'Expert system design and architecture consulting for complex enterprise solutions.',
    features: [
      'System Design & Architecture',
      'Scalability Planning',
      'Performance Optimization',
      'Security Architecture',
      'Cloud Migration',
      'Technical Consulting'
    ],
    technologies: ['AWS', 'Azure', 'Google Cloud', 'Microservices', 'Event-driven Architecture']
  },
  {
    id: 'erp',
    category: 'business',
    icon: 'fas fa-cubes',
    title: 'Frappe ERPNext & Banking ERP',
    description: 'Frappe Framework and ERPNext for banking and finance, with every core module plus the payables, receivables, procurement, assets, inventory and intercompany processes a bank finance team runs.',
    features: [
      'Frappe Framework & ERPNext custom apps',
      'Accounting, Buying, Selling and Stock',
      'Assets, CRM, Projects and Support',
      'Manufacturing, Quality, Maintenance and Website',
      'Human Resources, Payroll and Point of Sale',
      'Loan Management',
      'Procurement & Accounts Payable',
      'Accounts Receivable',
      'Fixed Assets & Inventory',
      'Intercompany Accounting & Expense Allocations',
      'Core banking, regulatory reporting and external integrations',
      'Secure SDLC, OWASP, ISO 27001 and PCI-DSS',
      'Custom ERP Development',
      'ERP Integration & Migration',
      'ERP Training & Support'
    ],
    technologies: ['Frappe', 'ERPNext', 'Python', 'MariaDB', 'PostgreSQL', 'Oracle', 'SQL Server', 'Java', 'Spring', 'Node.js', 'C#', 'REST', 'SOAP', 'GraphQL', 'Jenkins', 'Odoo', 'SAP']
  },
  {
    id: 'training',
    category: 'business',
    icon: 'fas fa-graduation-cap',
    title: 'Training & Tutoring Services',
    description: 'Professional training programs and technical tutoring for teams and individuals.',
    features: [
      'Software Development Training',
      'VoIP & Telecommunications',
      'System Architecture',
      'Team Workshops',
      'One-on-One Tutoring',
      'Certification Preparation'
    ],
    technologies: ['Custom Curriculum', 'Hands-on Projects', 'Code Reviews', 'Mentorship']
  },
  {
    id: 'support',
    category: 'support',
    icon: 'fas fa-headset',
    title: 'Support Services & Managed IT',
    description: 'Comprehensive 24/7 technical support, system maintenance, and managed IT services to keep your infrastructure running smoothly.',
    features: [
      '24/7 Technical Support',
      'System Monitoring & Maintenance',
      'Managed IT Services',
      'Infrastructure Management',
      'Proactive Issue Resolution',
      'Performance Optimization',
      'Backup & Disaster Recovery',
      'Help Desk Services'
    ],
    technologies: ['Monitoring Tools', 'Ticketing Systems', 'Remote Support', 'Automation', 'Cloud Management']
  },
  {
    id: 'security',
    category: 'support',
    icon: 'fas fa-shield-alt',
    title: 'Cyber Security Solutions',
    description: 'Advanced cybersecurity services including vulnerability assessments, penetration testing, endpoint security, and security awareness training.',
    features: [
      'Vulnerability Assessment & Penetration Testing',
      'Cyber Security Awareness Training',
      'Endpoint Security Solutions',
      'Firewall Configuration & Management',
      'CCTV with Video Analytics',
      'Security Audits & Compliance',
      'Incident Response & Forensics',
      'Security Architecture Design'
    ],
    technologies: ['Security Tools', 'Penetration Testing', 'SIEM', 'Firewalls', 'Endpoint Protection', 'Security Frameworks']
  },
  {
    id: 'whatsapp',
    category: 'ai',
    icon: 'fab fa-whatsapp',
    title: 'Business Automation via WhatsApp Integration',
    description: 'Intelligent WhatsApp chatbots and automation solutions for customer service, sales, product management, and business process automation.',
    features: [
      'WhatsApp Chatbot Development',
      'Business Process Automation',
      'Customer Support Automation',
      'Product & Service Management',
      'Order Processing & Fulfillment',
      'Payment Integration',
      'Multi-language Support',
      '24/7 Customer Engagement',
      'Analytics & Reporting',
      'CRM Integration'
    ],
    technologies: ['WhatsApp Business API', 'Node.js', 'Python', 'Dialogflow', 'Twilio', 'Chatbot Frameworks', 'NLP', 'REST APIs']
  },
  {
    id: 'hired-services',
    category: 'telecom',
    icon: 'fas fa-users-cog',
    title: 'Hired Development Team Services',
    description: 'We provide our expert development team to work on your behalf on agreed terms. Our team handles everything from setup to maintenance, ensuring your systems run smoothly.',
    features: [
      'PBX System Setup & Configuration',
      'Call Centre Systems Setup',
      'FreePBX & Asterisk Setup',
      'A2 Billing Setup',
      'Hardware & Network Maintenance',
      'Support for Existing Services & Platforms',
      'Hardware Support & Troubleshooting',
      'System Monitoring & Optimization',
      '24/7 Technical Support',
      'Custom Solutions Development'
    ],
    technologies: ['FreePBX', 'Asterisk', 'A2Billing', 'PBX Systems', 'Network Infrastructure', 'Hardware Support', 'System Administration']
  }
]

export const processSteps = [
  { icon: 'fa-magnifying-glass', title: 'Discover', text: 'Understand the problem, the users and what success looks like.' },
  { icon: 'fa-pen-ruler', title: 'Design', text: 'Architecture, data flows and a delivery plan you can review.' },
  { icon: 'fa-code', title: 'Build', text: 'Iterative delivery with demos, code reviews and tests.' },
  { icon: 'fa-rocket', title: 'Ship', text: 'CI/CD, monitoring and a calm, well-documented launch.' },
  { icon: 'fa-life-ring', title: 'Support', text: 'Maintenance, optimisation and help when you need it.' }
]
